import { SdkBaseSectionModel } from './baseSection';

export class SdkPopoverModel extends SdkBaseSectionModel {}
